import { LoadableContent } from 'utils/status';

export function usePostTradeContent<T>(content: LoadableContent<readonly T[], 'auth' | 'unknown'>) {
  return {
    content: content.status === 'success' ? content.content : undefined,
    isLoading: content.status === 'loading',
    hasAuthError: content.status === 'error' && content.error === 'auth',
    hasUnknownError: content.status === 'error' && content.error === 'unknown',
    isEmptyContent: content.status === 'success' && content.content.length === 0,
  };
}
